import type { EAudioGenerationProvider } from "../constants/enums"

export const DEV_FEATURE_FLAG_OVERRIDE_TTL_SECONDS = 60 * 60 * 24 * 7
const DEV_FEATURE_FLAG_OVERRIDE_ENVIRONMENTS = new Set(["local", "dev", "test"])

export const isDevFeatureFlagOverrideEnvironment = (environment: string): boolean =>
  DEV_FEATURE_FLAG_OVERRIDE_ENVIRONMENTS.has(environment)

export enum EFeatureFlag {
  DEFAULT_LLM = "default-llm",
  DEV_PANEL_EXAMPLE = "dev-panel-example",
  ENABLE_STORYBOARD_GENERATION = "enable-storyboard-generation",
  ENABLE_VIDEO_GENERATION = "enable-video-generation",
  HARD_PAYWALL = "hard-paywall-1",
  LIMIT_FREE_PLAN = "limit-free-plan",
  RENDER_LOCATION = "render-location",
  SKIP_VIDEO_GENERATION_VALIDATION = "skip-video-generation-validation",
  TEST_EXPERIMENT = "test-experiment",
  TTS_GENERATION_PROVIDER = "tts-generation-provider",
  BANNER_DOWN = "banner-down", // https://us.posthog.com/project/35747/feature_flags/30822
  UNDETECTABLE_HUMANIZATION_MODEL = "undetectable-humanization-model", // https://us.posthog.com/project/35747/feature_flags/90980
  // Kill-switch for the generation concurrency limiter. OFF (default) = shadow (measure, never
  // enforce). ON = enforce (over-cap jobs QUEUE). https://us.posthog.com/project/107483/feature_flags/716437
  GENERATION_CONCURRENCY_ENFORCE = "generation-concurrency-enforce",
}

export type TFeatureFlagValue = boolean | string

export interface IFeatureFlagOverride {
  value: TFeatureFlagValue
  payload?: unknown
}

export interface IDevPanelExamplePayload {
  message?: string
  accent?: string
}

export interface EFeatureFlagPayloads {
  [EFeatureFlag.DEV_PANEL_EXAMPLE]: IDevPanelExamplePayload
  [EFeatureFlag.TTS_GENERATION_PROVIDER]: EAudioGenerationProvider
  [EFeatureFlag.BANNER_DOWN]: boolean
  [EFeatureFlag.UNDETECTABLE_HUMANIZATION_MODEL]: boolean
  [EFeatureFlag.GENERATION_CONCURRENCY_ENFORCE]: boolean
}
